import {gql} from 'apollo-angular';

export const GET_GAME_TROPHY_HUNT_SCHOOL_CLASS = gql`
  query GetGameTrophyHuntSchoolClass($schoolClassId: Int!) {
    getGameTrophyHuntSchoolClass(schoolClassID: $schoolClassId) {
      id
      totalSteps
      lastStep
    }
  }
`;
